// Announcement
var tryCount = 0;
function initAnnouncement() {
    var CookieName = "announcements";
    var closeButton = document.getElementById('announcement__close');
    var announcementPanel = document.querySelector('.announcement');

    if (closeButton == null || announcementPanel == null) {
        console.error('No panel or close button found for announcement');
    } else {
        var announcementId = announcementPanel.getAttribute('data-announcement-id');

        closeButton.addEventListener("click", function (e) {
            var dateTime = new Date();
            console.log(moment(dateTime).format('YYYY-MM-DD , h:mm:ss a'));

            announcementPanel.classList.add('hidden');
            document.body.classList.remove("body--announcement-visible");

            // Read the current cookie value
            let cookieValue = Cookies.get(CookieName);
            let announcements = {};

            if (cookieValue) {
                announcements = JSON.parse(cookieValue);
            }

            // Update the announcements object
            announcements[announcementId] = {
                createdDate: moment(dateTime).format('YYYY-MM-DD , h:mm:ss a'),
                closed: true
            };

            // Set the updated cookie
            Cookies.set(CookieName, JSON.stringify(announcements), {
                expires: 365,
            });
        });
    }
};
function updateAnnouncementOffset() {
    const announcement = document.querySelector('.announcement');
    if (!announcement) return;

    const height = announcement.offsetHeight;

    // Write the height into a CSS variable
    document.documentElement.style.setProperty('--announcement-height', height + 'px');
}

// Run once after DOM is ready
window.addEventListener('load', updateAnnouncementOffset);

// Also update on resize (fonts, wrapping, responsive layouts)
window.addEventListener('resize', updateAnnouncementOffset);

// Also update after closing the announcement
document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'announcement__close') {
        setTimeout(updateAnnouncementOffset, 10);
    }
});

function deferAnnouncement(method) {
    if (tryCount > 20) {
        console.error('moment object was never populated. Failed to setup announcement');
    } else {
        if (typeof moment !== 'undefined') {
            console.log('All loaded and ready for announcement cookies');
            method();
        } else {
            setTimeout(function () {
                console.log('Awaiting for 50ms before calling defer again');
                tryCount++;
                deferAnnouncement(method);
            }, 50);
        }
    }
}

deferAnnouncement(function () {
    initAnnouncement();
});
